import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import { usePendingSearch } from './PendingSearchContext';

const DEBOUNCE_MS = 300;

/** 待办底栏共用搜索：写入 PendingSearchContext，各 Tab 同词筛选 */
const PendingListFooterSearch = () => {
	const { keyword, setKeyword } = usePendingSearch();
	const [value, setValue] = useState(keyword);
	const debounceRef = useRef(null);

	useEffect(() => {
		setValue(keyword);
	}, [keyword]);

	useEffect(() => {
		if (debounceRef.current) clearTimeout(debounceRef.current);
		debounceRef.current = setTimeout(() => {
			const next = value.trim();
			setKeyword(next);
		}, DEBOUNCE_MS);
		return () => {
			if (debounceRef.current) clearTimeout(debounceRef.current);
		};
	}, [value, setKeyword]);

	const handleClear = () => {
		if (debounceRef.current) clearTimeout(debounceRef.current);
		setValue('');
		setKeyword('');
	};

	const handleKeyDown = (event) => {
		if (event.key !== 'Enter') return;
		event.preventDefault();
		if (debounceRef.current) clearTimeout(debounceRef.current);
		setKeyword(value.trim());
	};

	const hasValue = Boolean(value.trim());

	return (
		<InputGroup className='pending-list-footer-search' size='sm'>
			<FormControl
				type='search'
				inputMode='search'
				enterKeyHint='search'
				placeholder='搜索订单、客户、总价、应收…'
				value={value}
				onChange={(e) => setValue(e.target.value)}
				onKeyDown={handleKeyDown}
				aria-label='搜索全部待办（订单、客户、总价、应收）'
				autoComplete='off'
				className='shadow-none'
			/>
			{hasValue ? (
				<Button type='button' variant='outline-secondary' className='border-300' onClick={handleClear} title='清空搜索' aria-label='清空搜索'>
					<FontAwesomeIcon icon='times' className='fs-10' />
				</Button>
			) : (
				<span className='input-group-text border-300 bg-transparent text-500 px-2' aria-hidden>
					<FontAwesomeIcon icon='search' className='fs-10' />
				</span>
			)}
		</InputGroup>
	);
};

export default PendingListFooterSearch;
